
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.4142 0.585786C16.1953 1.36684 16.1953 2.63316 15.4142 3.41421L8.82843 10L15.4142 16.5858C16.1953 17.3668 16.1953 18.6332 15.4142 19.4142C14.6332 20.1953 13.3668 20.1953 12.5858 19.4142L4.58579 11.4142C3.80474 10.6332 3.80474 9.36684 4.58579 8.58579L12.5858 0.585786C13.3668 -0.195262 14.6332 -0.195262 15.4142 0.585786Z"}})])
          )
        }
      }
    